<template>
  <v-layout column>
    <v-flex>
      <v-toolbar>
        <v-toolbar-title>Register</v-toolbar-title>
      </v-toolbar>
        <form name="filmklubb-form" autocomplete="off">
          <v-text-field
            label="email"
            v-model="email"
          ></v-text-field>
            <br>
            <v-text-field
              label="password"
              type="password"
              v-model="password"
              autocomplete="new-password"
              ></v-text-field>
            <br>
            <div class="error" v-html="error" />
            <v-btn @click="register">Register</v-btn>
          </form>
    </v-flex>
  </v-layout>
</template>

<script>
import AuthenticationService from '@/services/authentication_service'
export default {
  data () {
    return {
      email: '',
      password: '',
      error: null
    }
  },
  methods: {
    async register () {
      try {
        const response = await AuthenticationService.register({
          email: this.email,
          password: this.password
        })
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
      } catch (error) {
        this.error = error.response.data.error
      }
    }
  }
}
</script>

<style scoped>
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue